import api from './api';
import { CrossSystemLink, PortfolioSummary, Provenance, PersonaLineageTree, SendToPayload } from '../types/crossSystem';

export const crossSystemService = {
  getLinks: async (entityType: string, entityId: string): Promise<CrossSystemLink[]> => {
    const resp = await api.get(`/cross-system/links/${entityType}/${entityId}`);
    return resp.data;
  },

  getPortfolio: async (personaId: string): Promise<PortfolioSummary> => {
    const resp = await api.get(`/cross-system/persona/${personaId}/portfolio`);
    return resp.data;
  },

  getProvenance: async (artifactId: string): Promise<Provenance> => {
    const resp = await api.get(`/cross-system/artifact/${artifactId}/provenance`);
    return resp.data;
  },

  getLineageTree: async (): Promise<PersonaLineageTree> => {
    const resp = await api.get('/personas/lineage/tree');
    return resp.data;
  },

  getAncestors: async (personaId: string) => {
    const resp = await api.get(`/personas/lineage/${personaId}/ancestors`);
    return resp.data;
  },

  getDescendants: async (personaId: string) => {
    const resp = await api.get(`/personas/lineage/${personaId}/descendants`);
    return resp.data;
  },

  sendTo: async (payload: SendToPayload) => {
    const resp = await api.post('/cross-system/send', payload);
    return resp.data;
  },
};
